import CRUDService from "../../services/base/CRUDService";

export default class EpcDistanceService extends CRUDService {

  static ALL_URL = "polygon/v1/epcs/";

  getBaseURL() {
    return EpcDistanceService.ALL_URL;
  }

}



// WEBPACK FOOTER //
// ./src/map/epc-distance/EpcDistanceService.js